import React from 'react';

import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroBanner from "../components/about/HeroBanner";
import Counters from "../components/Counters";
import VisionMission from "../components/about/VisionMission";
import WhatSetsApart from "../components/about/WhatSetsApart";
import AboutTheFounder from "../components/about/AboutTheFounder";
import Certification from "../components/Certification";
import Testimonials from "../components/Testimonials";
import LatestBlog from "../components/LatestBlog";
import Contact from "../components/Contact";
import InstaConnect from "../components/InstaConnect";
import MiniFaq from "../components/MiniFaq";


export default function AboutUs() {
    return (
        <>
            <Header />

            <HeroBanner />

            <section id="counters-section">
                {/* <div className="counters-container"> */}
                <Counters />
                <div className="counter-text-container">
                    <p className="counter-text-bottom">Harshita School of Music (HSM), founded by Harshita Rewadia, India’s first Opera Queen and renowned Western Vocalist, is a professional academy dedicated to nurturing musical talent with passion, precision, and purpose. With 350+ students across diverse disciplines—ranging from Western Vocals, Bollywood Singing, Hindustani Classical, to Instrumental mastery in Guitar, Keyboard, Drums, and more—HSM has become a trusted name in holistic music education.
                    </p>
                    <p className="counter-text-bottom">We believe music is not just an art, but a journey of self-discovery and expression. At HSM, students receive world-class training under specialized teachers for every subject, ensuring individual attention and structured growth. Our programs cater to both hobby learners and aspiring professionals, helping them build careers in music while enjoying every step of the process.
                    </p>
                    {/* </div> */}

                    <div className="on-campus-categories">
                        <div className="category-grid">
                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
                                    </svg>
                                </div>
                                <span className="category-text">Expert Faculty</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                        <circle cx="9" cy="7" r="4" />
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                    </svg>
                                </div>
                                <span className="category-text">Personalized Training</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="13.5" cy="6.5" r="1.5" />
                                        <path d="M7 2l3 7h4l3-7" />
                                        <path d="M10 9v10" />
                                        <path d="M14 9v10" />
                                    </svg>
                                </div>
                                <span className="category-text">Acoustic Classrooms</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
                                        <path d="M12 6v2m0 8v2" />
                                    </svg>
                                </div>
                                <span className="category-text">Real-Time Feedback</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                        <polyline points="9,22 9,12 15,12 15,22" />
                                    </svg>
                                </div>
                                <span className="category-text">Premium Instruments</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                                        <line x1="8" y1="21" x2="16" y2="21" />
                                        <line x1="12" y1="17" x2="12" y2="21" />
                                    </svg>
                                </div>
                                <span className="category-text">Recording Studio</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                        <line x1="3" y1="6" x2="21" y2="6" />
                                        <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg>
                                </div>
                                <span className="category-text">Cross-Discipline Exposure</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                                    </svg>
                                </div>
                                <span className="category-text">Exam Preparation</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                    </svg>
                                </div>
                                <span className="category-text">Stage Showcases</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M9 18V5l12-2v13" />
                                        <circle cx="6" cy="18" r="3" />
                                        <circle cx="18" cy="16" r="3" />
                                    </svg>
                                </div>
                                <span className="category-text">Ensemble Practice</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M3 21h18" />
                                        <path d="M5 21V7l8-4v18" />
                                        <path d="M19 21V11l-6-4" />
                                        <path d="M9 9h.01" />
                                        <path d="M9 12h.01" />
                                        <path d="M9 15h.01" />
                                        <path d="M9 18h.01" />
                                    </svg>
                                </div>
                                <span className="category-text">Peer Collaboration</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="12" cy="12" r="3" />
                                        <path d="M12 1v6m0 6v6" />
                                        <path d="M15.5 4.5l-3 3m0 0l-3-3m3 3l3-3" />
                                        <path d="M8.5 19.5l3-3m0 0l3 3m-3-3l-3 3" />
                                    </svg>
                                </div>
                                <span className="category-text">Performance Coaching</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                                    </svg>
                                </div>
                                <span className="category-text">Industry Networking</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                                    </svg>
                                </div>
                                <span className="category-text">Creative Workshops</span>
                            </div>

                            <div className="category-card">
                                <div className="category-icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                                    </svg>
                                </div>
                                <span className="category-text">Career Guidance</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <VisionMission />

            <WhatSetsApart />

            <AboutTheFounder />

            <Certification />

            <Testimonials />

            <LatestBlog />

            <Contact />

            <InstaConnect />

            <MiniFaq />

            <Footer />
        </>
    );
}